<template>
  <main id="main" class="--full">
    <section v-if="page" class="section section__content">
      <ReturnButton />
      <h1 class="title">{{ page.title }}</h1>
      <RawHtml :html="page.content" />
      <ScrollTopButton />
    </section>
  </main>
</template>

<script>
import { RawHtml } from '@/components/global'
import { ReturnButton, ScrollTopButton } from '@/components/small'

export default {
  name: 'TitleContentPage',
  components: { RawHtml, ReturnButton, ScrollTopButton },
  props: {
    page: {
      type: Object,
      default: null,
    },
  },
}
</script>
